/* SPDX-License-Identifier: Apache-2.0 */
/* SPDX-FileCopyrightText: 2024-2026 OKTET LTD */
import { AdminAnalyticsPageContainer } from '@/bublik/features/analytics';

const AdminAnalyticsPage = () => {
	return <AdminAnalyticsPageContainer />;
};

export { AdminAnalyticsPage };
